import client from "./client";

// قاعدة الـAPI التي تعمل فعليًا (نفس ما يستخدمه التطبيق لكل النداءات الناجحة).
const API_BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

// رابط PDF عام قصير العمر. نبنيه هنا من REACT_APP_BACKEND_URL لضمان وصوله لخادم الـAPI الصحيح،
// مستقلًا عن APP_PUBLIC_URL على الخادم الذي قد يكون فارغًا في الإنتاج فيُنتج رابطًا نسبيًا خاطئًا
// يصل لخادم الواجهة فيعيد index.html (ملف PDF تالف).
export const pdfTicket = async (kind, params) => {
  const data = (await client.post("/reports/pdf-ticket", { kind, params })).data;
  return { ...data, pdf_url: `${API_BASE}/api/reports/pdf/${data.ticket}` };
};

// نرفع نفس HTML نافذة التقرير ليُطبع على الخادم بمتصفح حقيقي (تصميم مطابق + عربية سليمة).
export const attachPdfHtml = (ticket, html) =>
  client.post(`/reports/pdf-ticket/${ticket}/html`, { html });

// توليد PDF بطلب واحد مباشر من HTML التقرير (WeasyPrint في الذاكرة) — بلا تذكرة/تسخين/استطلاع.
export const renderPdfDirect = async (html, filename = "report") => {
  const res = await client.post("/reports/pdf", { html, filename }, { responseType: "blob" });
  return res.data;
};
